// extracted by mini-css-extract-plugin
export default {"emoticonButton":"EmoticonButton_emoticonButton__fx4DF"};